import { Flame, MoonStar, BedDouble, HeartPulse } from "lucide-react";

// Maps each printable slug to its in-app tracker config.
// `type` must match backend TRACKER_TYPES.
export const TRACKERS = {
  "hot-flash-diary": {
    type: "hot-flash",
    title: "Hot Flash Diary",
    icon: Flame,
    levels: ["Mild", "Medium", "Strong"],
    noteLabel: "What was happening",
    notePlaceholder: "Food, drink, stress, activity…",
  },
  "weekly-sleep-quality-journal": {
    type: "sleep-quality",
    title: "Sleep Quality Journal",
    icon: BedDouble,
    levels: ["Mild", "Medium", "Strong"],
    noteLabel: "Sleep impact (hours & quality)",
    notePlaceholder: "e.g. slept 5 hours, woke twice…",
  },
  "sleep-wellness-tracker": {
    type: "sleep",
    title: "Sleep Wellness Tracker",
    icon: MoonStar,
    levels: ["Mild", "Moderate", "Significant"],
    noteLabel: "Observation & triggers",
    notePlaceholder: "Disturbances, timing, triggers…",
  },
  "emotional-wellness-tracker": {
    type: "emotional",
    title: "Emotional Wellness Tracker",
    icon: HeartPulse,
    levels: ["Mild", "Notable", "Significant"],
    noteLabel: "Situation & triggers",
    notePlaceholder: "What was happening and how you felt…",
  },
};

// Ordered list used by the Track screen's Trackers tab.
export const TRACKER_LIST = Object.entries(TRACKERS).map(([slug, cfg]) => ({ slug, ...cfg }));
